import styled from 'styled-components';

export const StyledUnsubscribePage = styled.div`
  .unsubscribe-page {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
    padding: 40px 20px;

    &__content {
      text-align: center;
      max-width: 400px;
    }

    &__icon {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 20px;
      font-size: 28px;
      background: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.limeGreen, 0.1)};
      color: ${({ theme }) => theme.colors.limeGreen};

      &--error {
        background: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.1)};
        color: ${({ theme }) => theme.colors.mainOrange};
      }
    }

    &__title {
      margin-bottom: 12px;
    }

    &__message {
      p {
        color: ${({ theme }) => theme.colors.raven};
        line-height: 1.6;
      }
    }
  }
`;
